import { ChangeDetectorRef, Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-external-screen-modal',
  imports: [MatButtonModule, CommonModule, MatDialogModule],
  templateUrl: './external-screen-modal.component.html',
  styleUrl: './external-screen-modal.component.scss'
})
export class ExternalScreenModalComponent {

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public dialogueData:any, private modal: MatDialog, private cdr: ChangeDetectorRef) {
    console.log(this.dialogueData);
  }

  ngAfterViewInit(): void {
    this.loadIframe();
  }

  loadIframe() {   
    const iframe = document.getElementById('externalPage') as HTMLIFrameElement;
    if(iframe) {
      iframe.src = this.dialogueData.iframeUrl;
    }
  }

  closeModal() {
    this.modal.closeAll();
  }
}
